import Router from 'next/router';
import { SessionProvider } from 'next-auth/react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports, import-x/no-named-as-default -- This is the only place we can import posthog directly (Pages Router), for configuration purposes.
import posthog from 'posthog-js';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { SWRConfig } from 'swr';
import '@stripe/stripe-js'; // This is needed to run the stripe fraud tracking on every page
import { LoggedInEffects } from 'components/Instrumentation/LoggedIn';

import { swrConfig } from 'lib/fetchJson';
import { posthogConfigPagesRouter } from 'lib/posthog/PostHogConfig';
import { PostHogProvider } from 'posthog-js/react';

// https://nextjs.org/docs/basic-features/built-in-css-support#adding-a-global-stylesheet
import '../styles/globals.css';

const App = ({ Component, pageProps }) => {
  const oldUrlRef = useRef('');

  // Posthog Init for Pages Router
  useEffect(() => {
    posthog.init(
      process.env.NEXT_PUBLIC_POSTHOG_KEY || '',
      posthogConfigPagesRouter
    );

    const handleRouteChange = () => posthog?.capture('$pageview');

    const handleRouteChangeStart = () =>
      posthog?.capture('$pageleave', {
        $current_url: oldUrlRef.current,
      });

    Router.events.on('routeChangeComplete', handleRouteChange);
    Router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange);
      Router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, []);

  return (
    <SessionProvider session={pageProps.session}>
      <SWRConfig value={swrConfig}>
        <PostHogProvider client={posthog}>
          <LoggedInEffects />
          <Component {...pageProps} />
        </PostHogProvider>
      </SWRConfig>
    </SessionProvider>
  );
};

App.propTypes = {
  Component: PropTypes.func.isRequired,
  pageProps: PropTypes.object.isRequired,
  err: PropTypes.object,
};

export default App;
